import { useContext } from 'react';
import { createContext } from 'react';

import { ProductPriceProps } from '../@types/ProductPriceProps';

export const ProductPriceContext = createContext<ProductPriceProps>({} as ProductPriceProps);

ProductPriceContext.displayName = 'ProductPrice';

const ProductPriceProvider = (props: ProductPriceProps) => (
	<ProductPriceContext.Provider value={props}>{props.children}</ProductPriceContext.Provider>
);

export const useProductPrice = () => {
	const context = useContext(ProductPriceContext);

	return context;
};

export default ProductPriceProvider;
